import type { BorderedBoxProps } from './BorderedBox.types';

export const BorderedBox = ({ children, className }: BorderedBoxProps) => {
  return (
    <div className={`p-6 rounded-2xl border border-[#0000000D] ${className ?? ''}`}>{children}</div>
  );
};
